import FeatureSelectModal from '@pc/components/Works/Panel/SelectModal/FeatureSelectModal'
import ButtonGroup from '@pc/components/Works/Panel/shared/Button/ButtonGroup'
import ConditionParagraph from '@pc/components/Works/Panel/shared/ConditionParagraph'
import EmphasisHeading from '@pc/components/Works/Panel/shared/Heading/EmphasisHeading'
import type { SearchParamsAttributes, ConditionReducer } from '@pc/components/Works/Panel/types'
import buildConditionWords from '@pc/components/Works/Panel/utils/buildConditionWords'
import BaseSelectPanel from './BaseSelectPanel'

interface PropsType {
  params: SearchParamsAttributes
  conditionReducer: ConditionReducer
}

const FeatureSelectPanel = (props: PropsType) => {
  const { params, conditionReducer } = props

  const el = document.querySelector<HTMLElement>('.js-works-search-panel')
  const timeSlotsAttr = el?.dataset.worksWorkingTimeSlots
  const featureCategoriesAttr = el?.dataset.worksFeatureCategories
  const featuresAttr = el?.dataset.worksFeatures

  const featureData =
    timeSlotsAttr !== undefined && featureCategoriesAttr !== undefined && featuresAttr !== undefined
      ? {
          timeSlots: JSON.parse(timeSlotsAttr).data,
          featureCategories: JSON.parse(featureCategoriesAttr).data,
          features: JSON.parse(featuresAttr).data
        }
      : undefined

  const featureTitles = [
    conditionReducer.attributes.condition_title_maps.free_word,
    conditionReducer.attributes.condition_title_maps.keepup_day,
    conditionReducer.attributes.condition_title_maps.keepup_hour,
    conditionReducer.attributes.condition_title_maps.time_slots,
    conditionReducer.attributes.condition_title_maps.custom_codes,
    conditionReducer.attributes.condition_title_maps.features,
    conditionReducer.attributes.condition_title_maps.welcome,
    conditionReducer.attributes.condition_title_maps.except_haken,
    conditionReducer.attributes.condition_title_maps.except_medical_services,
    conditionReducer.attributes.condition_title_maps.accept_highschool_students,
    conditionReducer.attributes.condition_title_maps.except_night_work
  ]
    .flat()
    .filter((v): v is string => v != null)

  return (
    <BaseSelectPanel>
      <EmphasisHeading>こだわり条件</EmphasisHeading>
      <ConditionParagraph>{buildConditionWords(featureTitles)}</ConditionParagraph>
      <ButtonGroup>
        {featureData && (
          <FeatureSelectModal
            params={params}
            timeSlots={featureData.timeSlots}
            featureCategories={featureData.featureCategories}
            features={featureData.features}
          />
        )}
      </ButtonGroup>
    </BaseSelectPanel>
  )
}

export default FeatureSelectPanel
